import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "kv-section"
};
const _hoisted_2 = {
  class: "kv-content"
};
const _hoisted_3 = {
  class: "kv-title"
};
const _hoisted_4 = {
  class: "kv-sub"
};
const _hoisted_5 = {
  class: "kv-dots"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "text-block"
};
const _hoisted_8 = {
  class: "container"
};
const _hoisted_9 = {
  class: "block-right"
};
const _hoisted_10 = {
  class: "text-block grey"
};
const _hoisted_11 = {
  class: "container reverse"
};
const _hoisted_12 = {
  class: "block-left"
};
const _hoisted_13 = {
  class: "text-block"
};
const _hoisted_14 = {
  class: "container"
};
const _hoisted_15 = {
  class: "block-right"
};
import { ref, onMounted, onUnmounted } from 'vue';
import NavBar from '@/components/layout/NavBar.vue';
import Footer from '@/components/layout/Footer.vue';
import jdImg from '@/assets/imgs/jd.png';
import jjImg from '@/assets/imgs/jj.png';
import ylImg from '@/assets/imgs/yl.jpg';
import lbImg1 from '@/assets/imgs/1.jpg';
import lbImg2 from '@/assets/imgs/2.jpg';
import lbImg3 from '@/assets/imgs/3.jpg';

// KV 轮播

export default {
  __name: 'Scene',
  setup(__props) {
    const kvList = [{
      // pic: 'https://picsum.photos/seed/kv1/1920/1080 ',
      pic: lbImg1,
      title: '智能睡眠解决方案',
      sub: '为不同场景提供专业的睡眠科技'
    }, {
      // pic: 'https://picsum.photos/seed/kv2/1920/1080 ',
      // pic: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?auto=format&w=1920&q=80",
      pic: lbImg2,
      title: '合作共赢 · 共创未来',
      sub: '期待与各行业伙伴深度合作'
    }, {
      // pic: 'https://picsum.photos/seed/kv3/1920/1080 ',
      pic: lbImg3,
      title: '科技改善睡眠',
      sub: '让每个人都能享受优质睡眠'
    }];
    const kvIndex = ref(0);
    let timer = null;
    onMounted(() => {
      timer = setInterval(() => {
        kvIndex.value = (kvIndex.value + 1) % kvList.length;
      }, 5000);
    });
    onUnmounted(() => clearInterval(timer));
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(NavBar), _createElementVNode("section", _hoisted_1, [_createElementVNode("div", {
        class: "kv-slider",
        style: _normalizeStyle({
          transform: `translateX(-${kvIndex.value * 100}%)`
        })
      }, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(kvList, (s, i) => {
        return _createElementVNode("div", {
          key: i,
          class: "kv-item",
          style: _normalizeStyle({
            backgroundImage: `url(${s.pic})`
          })
        }, [_cache[0] || (_cache[0] = _createElementVNode("div", {
          class: "kv-overlay"
        }, null, -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("h1", _hoisted_3, _toDisplayString(s.title), 1), _createElementVNode("p", _hoisted_4, _toDisplayString(s.sub), 1)])], 4);
      }), 64))], 4), _createElementVNode("div", _hoisted_5, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(kvList, (_, i) => {
        return _createElementVNode("span", {
          key: i,
          class: _normalizeClass({
            active: i === kvIndex.value
          }),
          onClick: $event => kvIndex.value = i
        }, null, 10, _hoisted_6);
      }), 64))])]), _createElementVNode("section", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_cache[1] || (_cache[1] = _createStaticVNode("<div class=\"block-left\" data-v-dcd07906><h2 class=\"block-title\" data-v-dcd07906>居家睡眠场景<span class=\"title-line\" data-v-dcd07906></span></h2><p class=\"block-desc\" data-v-dcd07906> 我们的智能睡眠系统专为家庭设计，通过舒适的穿戴设备和手机App，帮助用户改善睡眠质量。系统能够监测睡眠状态，提供个性化的助眠音乐和科学的睡眠建议。 </p><p class=\"block-desc\" data-v-dcd07906> 无需复杂的设备安装，用户在家中即可享受专业的睡眠监测服务。系统会自动记录睡眠数据，生成易懂的睡眠报告，帮助用户了解自己的睡眠模式并逐步改善。 </p><ul class=\"milestone\" data-v-dcd07906><li data-v-dcd07906>简单易用：设备即戴即用，App操作简单直观</li><li data-v-dcd07906>科学有效：基于脑电监测，提供精准的睡眠分析</li><li data-v-dcd07906>隐私安全：数据本地处理，保护用户隐私</li></ul></div>", 1)), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
        class: "img-box",
        style: _normalizeStyle({
          backgroundImage: `url(${_unref(jjImg)})`
        })
      }, null, 4)])])]), _createElementVNode("section", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
        class: "img-box",
        style: _normalizeStyle({
          backgroundImage: `url(${_unref(jdImg)})`
        })
      }, null, 4)]), _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"block-right\" data-v-dcd07906><h2 class=\"block-title\" data-v-dcd07906>酒店睡眠场景<span class=\"title-line\" data-v-dcd07906></span></h2><p class=\"block-desc\" data-v-dcd07906> 「为酒店客户提供更优质的睡眠体验，打造差异化服务」 </p><p class=\"block-desc\" data-v-dcd07906> 我们的技术可以帮助酒店提升客户满意度，特别适合商务旅客和注重睡眠质量的客人。系统能够监测客人的睡眠状态，提供个性化的助眠环境。 </p><ul class=\"milestone\" data-v-dcd07906><li data-v-dcd07906>提升体验：为客人提供专业的睡眠监测和改善服务</li><li data-v-dcd07906>差异化竞争：帮助酒店在同质化竞争中脱颖而出</li><li data-v-dcd07906>数据支持：为酒店提供客房环境优化的数据参考</li></ul></div>", 1))])]), _createElementVNode("section", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_cache[3] || (_cache[3] = _createStaticVNode("<div class=\"block-left\" data-v-dcd07906><h2 class=\"block-title\" data-v-dcd07906>养老机构应用<span class=\"title-line\" data-v-dcd07906></span></h2><p class=\"block-desc\" data-v-dcd07906> 针对老年人群体的特殊需求，我们的系统可以提供无感化的睡眠监测和健康管理，帮助养老机构更好地照顾长者。 </p><div class=\"philosophy-grid\" data-v-dcd07906><div class=\"phil-item\" data-v-dcd07906><i class=\"iconfont icon-brain\" data-v-dcd07906></i><h4 data-v-dcd07906>健康监测</h4><p data-v-dcd07906>实时监测长者睡眠质量，及时发现异常情况</p></div><div class=\"phil-item\" data-v-dcd07906><i class=\"iconfont icon-music\" data-v-dcd07906></i><h4 data-v-dcd07906>舒适助眠</h4><p data-v-dcd07906>提供适合长者的助眠音乐和环境调节</p></div><div class=\"phil-item\" data-v-dcd07906><i class=\"iconfont icon-ai\" data-v-dcd07906></i><h4 data-v-dcd07906>智能预警</h4><p data-v-dcd07906>系统自动识别睡眠异常，及时通知护理人员</p></div></div><p class=\"block-desc\" style=\"margin-top:20px;\" data-v-dcd07906> 我们期待与酒店、养老机构等合作伙伴共同探索睡眠科技在不同场景的应用，为更多用户提供优质的睡眠体验。 </p></div>", 1)), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", {
        class: "img-box",
        style: _normalizeStyle({
          backgroundImage: `url(${_unref(ylImg)})`
        })
      }, null, 4)])])]), _cache[4] || (_cache[4] = _createElementVNode("section", {
        class: "cta-section"
      }, [_createElementVNode("div", {
        class: "container"
      }, [_createElementVNode("h3", null, "开启睡眠科技合作"), _createElementVNode("p", null, "如果您是酒店、养老机构或相关企业，欢迎与我们联系，共同探讨合作可能"), _createElementVNode("a", {
        href: "/contact",
        class: "cta-btn"
      }, "立即咨询合作")])], -1)), _createVNode(Footer)], 64);
    };
  }
};